<script setup>
/**
 * FormControlModulestructureSelectType
 * Composition-based wrapper around the standard select dropdown form control.
 * Contextually exposes internal picklist attributes when an entity type matches 'select',
 * automatically dropping its layout visibility otherwise.
 */
import {onMounted} from 'vue'
import {useFormStore} from '@/stores/form'
import FormControlTypeSelect from '@/common/form-control-type/FormControlTypeSelect.vue'

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

const formStore = useFormStore(props.formId)

// --- Lifecycle ---

onMounted(() => {
    if (!props.field || !props.currentData) return

    if (props.currentData.type === 'select') {
        // TODO - I don't think this ever does anything.
        formStore.setDefaultValue({
            name: props.field.name,
            value: ''
        })
    } else {
        // Hide the configuration selector if the schema target isn't a select menu dropdown
        props.field.hidden = true
    }

    // TODO - In nicks-business this field was varChar, so the default value should be "", but it was set to 0.
    // The field should be upgraded to a number field and the default value set back to 0.
})
</script>

<template>
    <FormControlTypeSelect v-bind="$props" v-if="!field.hidden"/>
</template>